import React from 'react';

// @ts-ignore
import { ListItem, ListItemText, ListItemIcon } from '@pwc/appkit-react/lib/List';
// @ts-ignore
import { Tooltip } from '@pwc/appkit-react/lib/Tooltip';
import { useDownloadBatchReport, useDownloadBatchZipReport } from '../../shared/mutations/batchReports';
import { useDownloadJournalFile } from '@mutations/journalFile';
import { downloadResponseFile, downloadResponseZipFile } from './downloadResponseFile';
import { shouldDownloadJobAsZip } from './helpers';
import { Job } from './types';
import Spinner from '../../shared/spinner.component';

type SucceededExportJobProps = {
  job: Job;
  isZipFile?: boolean,
};

const SucceededExportJob = ({
  job,
  isZipFile,
}: SucceededExportJobProps) => {
  const jobLabel = job.displayName || job.returnedValue?.filename || job.jobType;
  const jobType = job.jobType;
  const archiveJobLabel = job.returnedValue?.filename || job.jobType;
  const shouldDownloadAsZip = shouldDownloadJobAsZip(job, isZipFile);

  const {
    mutate: downloadBatchReport,
    isLoading: isDownloadingBatchReport,
  } = (jobType === 'generate-journal-file')
    ? useDownloadJournalFile(downloadResponseFile(jobLabel))
    : useDownloadBatchReport(shouldDownloadAsZip
      ? downloadResponseZipFile(jobLabel)
      : downloadResponseFile(jobLabel));

  const {
    mutate: downloadBatchZipReport,
    isLoading: isDownloadingZipBatchReport,
  } = useDownloadBatchZipReport(downloadResponseZipFile(archiveJobLabel));

  const downloadExportFile = () => {
    if (isZipFile) {
      downloadBatchZipReport({ fileName: job.returnedValue?.filename || 'not_found' });
    } else {
      downloadBatchReport({
        jobId: job.jobId,
        exportFormat: job.returnedValue?.exportFormat,
      });
    }
  };

  return (
    <ListItem>
      <ListItemText>{jobLabel}</ListItemText>
      <ListItemIcon
        className="ml-auto"
        icon={
          <Tooltip content="Download export file" placement="left" containerid="jobs-tooltip-container">
            {(isDownloadingBatchReport || isDownloadingZipBatchReport)
              ? <Spinner className="appkiticon" small />
              // eslint-disable-next-line react/jsx-no-bind
              : <span className="appkiticon icon-download" onClick={downloadExportFile}/> }
          </Tooltip>
        }
      />
    </ListItem>
  );
};

export default SucceededExportJob;
